var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
var StyledDeadlineText = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0.25rem 0 1rem 0;\n  color: rgb(108, 117, 125);\n  font-size: 0.9rem;\n  font-weight: bold;\n"], ["\n  padding: 0.25rem 0 1rem 0;\n  color: rgb(108, 117, 125);\n  font-size: 0.9rem;\n  font-weight: bold;\n"])));
var StyledIcon = styled(FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1rem;\n  margin-right: 0.25em;\n  vertical-align: -0.1em;\n"], ["\n  font-size: 1rem;\n  margin-right: 0.25em;\n  vertical-align: -0.1em;\n"])));
var Deadline = function (_a) {
  var deadline = _a.deadline;
  if (!deadline) {
    return React.createElement(React.Fragment, null);
  }
  return React.createElement(StyledDeadlineText, null, React.createElement(StyledIcon, {
    icon: faClock
  }), "Deadline: " + deadline.toLocaleString());
};
export default Deadline;
var templateObject_1, templateObject_2;